// extracted by mini-css-extract-plugin
export default {"fullWidth":"xm-z","image":"ym-z","lazyLoadPicture":"zm-z","lazyLoadSpinner":"Am-z","lazyLoadSpin":"Bm-z","lazyLoadImage":"Cm-z","hasStyledAspectRatio":"Dm-z"};